import React from "react";
import { Link } from "react-router-dom";
import { Navbar } from "../components";
import "../styles/PageNotFound.css"

const PageNotFound = () => {
  return (
    <>
      <Navbar />
      <div className="not-found-page">
        <div className="not-found-card">
          <div className="not-found-glow" />

          <h1 className="not-found-code">404</h1>

          <h2 className="not-found-title">
            Page Not Found
          </h2>

          <p className="not-found-description">
            The page you're looking for doesn’t exist or may have
            been moved. Let’s get you back to shopping.
          </p>

          <Link to="/" className="not-found-btn">
            <i className="fa fa-arrow-left" />
            Go Back Home
          </Link>
        </div>
      </div>

    </>
  );
};

export default PageNotFound;
